var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentLoaded)?_c('div',{staticClass:"position-relative w-100"},[_c(_vm.content.layout,{tag:"component",staticClass:"position-absolute-center",attrs:{"content":_vm.content}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }